import { render, staticRenderFns } from "./SuperStar.vue?vue&type=template&id=295d261d&"
import script from "./SuperStar.vue?vue&type=script&lang=js&"
export * from "./SuperStar.vue?vue&type=script&lang=js&"
import style0 from "./SuperStar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports